/**
 * 拼单购物车商品
 */
import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Icon } from 'components'
import { cartMobx, orderMobx, productMobx } from 'restaurant'
import { buyTogetherMobx, multiPersonMobx } from '@mobxStore'
import ProductItem from './ProductItem'
import CashierController from '@ctrls/cashierController'
import './index.scss'

interface IProps {
  handleOutCart: () => void;
}

const BTCartItem: React.FC<IProps> = (props) => {
  const [listMap, setListMap] = useState<{[key: string]: any}>({})
  const { handleOutCart } = props

  const handleAddRequiredProduct = (productNo: string, lackCnt: number) => {
    const product = productMobx.noToViewProductMap[productNo]
    if (product) {
      buyTogetherMobx.prepareCartFormMenuForCartItemChange(productNo)
      CashierController.handleProductToCart({ type: 'add', product, directAddCnt: lackCnt })
    }
  }

  const getOrderMap = () => {
    let map = {}
    orderMobx.order.detailList.forEach((item) => {
      if (['product', 'FixedCombo', 'OptionalCombo'].includes(item.itemType)) {
        const picsIndex = orderMobx.order.picsProduct?.indexOf(item.productNo)
        let pic = ''
        const picString = (orderMobx.order.pics || [])[picsIndex]
        try {
          const picInfo = JSON.parse(picString)
          pic = picInfo?.[0]?.url || ''
        } catch (e) {
          pic = picString || ''
        }
        const newItem = {
          ...item,
          pic
        }
        map[item.addUserId] ? map[item.addUserId].push(newItem) : (map[item.addUserId] = [newItem])
      }
    })
    return map
  }

  useEffect(() => {
    setListMap(orderMobx.order.ordersId ? getOrderMap() : cartMobx.viewUserCartItems)
  }, [multiPersonMobx.multiPersonMap, orderMobx.order, cartMobx.viewUserCartItems])
  return (
    <div className='btcart-item-container'>
      {multiPersonMobx.currentPersonInfo.isOwner && !!cartMobx.requiredProductResult.items.length && (
        <div id='requiredProductTip' className='required-product-tip' data-cypid='requiredProductTip' tabIndex={-1}>
          <div className='required-product-title'>
            <strong>{i18n.t('cart.requiredProductTitle')}</strong>
          </div>
          <div className='required-product-list'>
            {cartMobx.requiredProductResult.items.map(item => item.type === 'category' ? (
              <div className='required-product-item required-product-category-item' key={`${item.type}_${item.categoryNo}`}>
                <div className='required-product-category-title'>
                  <span className='required-product-name'>{item.name}</span>
                  <span className='required-product-lack'>{i18n.t('cart.requiredProductItemLack', { count: item.lackCnt })}</span>
                </div>
                <div className='required-product-options'>
                  {(item.products || []).map(product => (
                    <div className='required-product-option' key={product.productNo}>
                      <span className='required-product-name'>{product.name}</span>
                      <button type='button' disabled={!product.isAvailable} onClick={() => handleAddRequiredProduct(product.productNo, 1)}>
                        {i18n.t('cart.requiredProductAdd')} <Icon name='tianjia' />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className='required-product-item' key={`${item.type}_${item.productNo}`}>
                <div className='required-product-main'>
                  <span className='required-product-name'>{item.name}</span>
                  <span className='required-product-lack'>{i18n.t('cart.requiredProductItemLack', { count: item.lackCnt })}</span>
                </div>
                {item.productNo && (
                  <button type='button' onClick={() => handleAddRequiredProduct(item.productNo as string, item.lackCnt)}>
                    {i18n.t('cart.requiredProductAdd')} <Icon name='tianjia' />
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
      <div className='btcart-person-box'>
        {multiPersonMobx.currentPersonInfo.personId && <ProductItem key={multiPersonMobx.currentPersonInfo.personId} handleOutCart={handleOutCart} user={multiPersonMobx.currentPersonInfo.personId} list={(listMap[multiPersonMobx.currentPersonInfo.personId] || []).filter(item => !item.disabled)} isSelf />}
        {
          Object.keys(multiPersonMobx.multiPersonMap).map(user => {
            if (user !== multiPersonMobx.currentPersonInfo.personId) {
              const list = (listMap[user] || []).filter(item => !item.disabled)
              return <ProductItem key={user} user={user} list={list} />
            }
          })
        }
      </div>
    </div>
  )
}

export default observer(BTCartItem)
